import { Component, OnInit } from '@angular/core';
import {
  UntypedFormGroup,
  UntypedFormBuilder,
  UntypedFormControl,
  Validators,
} from '@angular/forms';
import { DataService, AuthService } from 'src/app/shared/services';
import { ConfConsequenceModel } from 'src/app/shared/models';
import { BsModalRef } from 'ngx-bootstrap/modal';
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';
import { ComponentModel } from '../../../../shared/models';

@Component({
  selector: 'app-conf-consequence-edit',
  templateUrl: './edit.component.html',
})
export class ConfConsequenceEditComponent implements OnInit {
  // Modal parameters
  items: any; // array of items to edit
  categoriesReference: [] = [];
  // form instance
  form!: UntypedFormGroup;

  // Usage mode
  mode: 'mass' | 'single' | 'new' = 'single';

  // Target Id's
  targetIds: number[] = [];

  // UI Flag
  isLoading = false;
  data = null;
  isSubmitted = false;
  showValidationError = false;

  // Form reference Data
  parentReference: any;

  /**
   * @param formBuilder
   * @param service
   * @param auth
   * @param bsModalRef
   * @param translate
   */
  constructor(
    private formBuilder: UntypedFormBuilder,
    protected service: DataService,
    public auth: AuthService,
    public bsModalRef: BsModalRef,
    public translate: TranslateService
  ) {
    this.isLoading = true;
  }

  /**
   *
   */
  async ngOnInit(): Promise<void> {
    // Sniff mode
    this.mode = this.sniffEditMode(this.items);

    // get target Ids
    this.targetIds = _.map(this.items, (el) => el.id);

    // Get default empty object
    if (['mass', 'new'].indexOf(this.mode) > -1) {
      this.items = [
        new ConfConsequenceModel({
          account: this.auth.getAccountId(),
        }),
      ];
    }

    // Build for
    this.form = this.getForm(this.items[0]);

    // Loading done !
    this.isLoading = false;
  }

  /**
   * Sniff usage mode from items configuration
   */
  sniffEditMode(items: [ComponentModel?]): 'mass' | 'single' | 'new' {
    // Empty array => New Item
    if (items === undefined || items.length === 0) {
      return 'new';

      // Else => Single Edit
    } else {
      return 'single';
    }
  }

  /**
   *
   */
  getForm(item: ConfConsequenceModel): UntypedFormGroup {
    return this.formBuilder.group({
      id: new UntypedFormControl(item.id),
      description: new UntypedFormControl(item.description, [
        Validators.required,
        Validators.pattern(/^(\s+\S+\s*)*(?!\s).*$/),
      ]),
      cost: new UntypedFormControl(item.cost, [
        Validators.required,
        Validators.min(0),
      ]),
      account: new UntypedFormControl(this.auth.getAccountId()),
      category: new UntypedFormControl(item.category.id, Validators.required),
    });
  }

  /**
   * Confirm callback with updated res
   */
  confirmFn = (res: any) => {};

  /**
   *
   */
  save(): boolean | void {
    this.showValidationError = true;
    if (!this.form || (this.form && !this.form.valid)) {
      return false;
    } else {
      // Query pointer
      let query;

      if (this.mode === 'new') {
        const tmpData = _.pickBy(this.form.value, (el) => el !== null);
        query = this.service.post('api/config/consequences', tmpData);
      } else if (this.mode === 'single') {
        query = this.service.update(
          'api/config/consequences',
          this.targetIds[0],
          this.form.value
        );
      }

      this.isSubmitted = true;
      query?.subscribe(
        (res) => {
          this.isSubmitted = false;
          this.confirmFn(res);
          this.bsModalRef.hide();
        },
        (err) => {
          console.log('err: ', err);
          this.isSubmitted = false;
        }
      );
    }
  }
}
